import { HttpMethod } from "@/types/https";
import { apiCall } from "../base";
import { ENDPOINT } from "../endpoint";

export interface ShopItem {
  id: number;
  name: string;
  shopName: string;
  location?: string;
}

export const ShopList = (params: any) => {
  const stringParams = JSON.stringify(params);
  return {
    name: `ShopList_${stringParams}`,
    handle: (): Promise<any> =>
      apiCall<any>({
        params,
        url: ENDPOINT.SHOPS,
        method: HttpMethod.GET,
      }),
  };
};
